<template>
  <AppLayout>
    <div class="inventory">
    <section id="suppliers-add">
      <div class="container">
        <h6 class="fw-bold" style="color: black !important">Add Stock/Batch Processing
          <button v-if="batchId" class="btn-default btn btn-sm pull-right" style="margin-top: 0px;float:right; border: 1px solid #000;" @click="splitBatchModal()" :disabled="isSplitting">
            <span v-if="isSplitting">Splitting <img src="../../../assets/images/loader.gif" style="width:14px; margin-left:6px"/></span>
            <span v-else>Split Receipt</span>
          </button>
          <button v-if="purchase" class="btn-default btn btn-sm pull-right" style="margin-top: 0px;float:right; border: 1px solid #000;margin-right: 15px;"  @click="this.$router.push('/purchases/pdf/'+purchase.id)">View PO</button>
        </h6>
        <div class="row mt-4">
          <h6 class="col-md-2 fw-bold" >1. Delivery Details</h6>
          <h6 class="col-md-10 fw-bold" v-if="!isInternal">2. Courier & Supplier Details</h6>
        </div>
        <div>
              <span v-if="!canProcess" class="text-muted">Process (complete at least one item)</span>
            <div class="row">
              <div class="col-md-1">
                  <div class="check-button">
                  <div class="form-group">
                      <label>Internal Delivery?</label>
                      <div class="components-button">
                  <span class="switcher switcher-1">
                      <input type="checkbox" id="switcher-1" v-model="isInternal">
                      <label for="switcher-1"></label>
                  </span>
                      </div>
                  </div>
                  </div>
              </div>
              <div class="col-md-1" v-if="!isInternal"></div>
              <div class="col-md-2" v-if="isInternal">
                <div class="form-group">
                  <label for="driver">Select Driver</label>
                  <select v-model="driverId" class="full" id="driver"  v-if="users.length > 0">
                      <option v-for="user in users" v-bind:Key="user.id" :value="user.id">
                          {{ user.name }}
                      </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2" v-if="!isInternal">
                <div class="form-group">
                  <label for="suppliers">Select Supplier</label>
                  <select v-model="supplierId" class="full" id="suppliers"  v-if="suppliers.length > 0">
                      <option v-for="supplier in suppliers" v-bind:Key="supplier.id" :value="supplier.id">
                          {{ supplier.name }}
                      </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2" v-if="!isInternal">
                <div class="form-group">
                  <label for="address">Driver's Name</label>
                  <input type="text" v-model="driver" id="address" class="form-control">
                </div>
              </div>
              <div class="col-md-2" v-if="!isInternal">
                <div class="form-group">
                  <label for="item-code">Contacts</label>
                  <input type="text" class="form-control" id="item-code" v-model="contacts">
                </div>
              </div>
              <div class="col-md-2" v-if="!isInternal">
                <div class="form-group">
                  <label for="item-code">Vehicle Reg No.</label>
                  <input type="text" class="form-control" id="item-code" v-model="vehicle">
                </div>
              </div>
            </div>

            <div class="row">
              <h6 class="col-md-5 fw-bold">2. Stock Description</h6>
              <h6 class="col-md-7 fw-bold">3. Consignment Details & Documents</h6>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Stock Category</label>
                  <select v-model="nogId" class="full" id="stockCategories"  v-if="nogs.length > 0">
                      <option v-for="nog in nogs" v-bind:Key="nog.id" :value="nog.id">
                          {{ nog.nog }}
                      </option>
                  </select>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="item-code">BPN Tags</label>
                  <select v-model="tagId" class="full" id="suppliers"  v-if="tags.length > 0">
                      <option v-for="tag in tags" v-bind:Key="tag.id" :value="tag.id">
                          {{ tag.tag }}
                      </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Project / Site</label>
                  <!--<input type="text" class="form-control" id="item-code" v-model="project">-->
                  <select v-model="project" class="full" id="projects"  v-if="projects?.length > 0">
                    <option v-for="proj in projects" v-bind:Key="proj.id" :value="proj.name">
                        {{ proj.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="item-code">PO No.</label>
                  <select v-model="purchaseId" class="full" id="stockCategories">
                    <option :value="null">None</option>
                    <option v-for="purchaseno in purchasenosFiltered" v-bind:key="purchaseno.id" :value="purchaseno.id">
                      {{ purchaseno.purchaseNo }} — {{ statusLabel(purchaseno.status) }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Select Document</label>
                  <select v-model="document" id="" class="full">
                      <option v-for="doc in documentTypes" :value="doc.name" :key="doc.id">{{doc.name}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="item-code">Reference 1</label>
                  <input type="text" class="form-control" id="item-code" v-model="reference1">
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="item-code">Reference 2</label>
                  <input type="text" class="form-control" id="item-code" v-model="reference2">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Upload Document</label>
                  <input type="file" class="form-control" id="item-code" ref="fileDocument" @change="handleFileChange">
                </div>
              </div>

              <div class="col-md-2 mt-4">
                <button v-if="batchId == ''" class="btn-style" @click="postBatch" :disabled="isCreatingBatch">
                  <span v-if="isCreatingBatch">
                    Creating Batch
                    <img src="../../../assets/images/loader.gif" style="width: 20px; margin-left: 5px"/>
                  </span>
                  <span v-else>Add Batch</span>
                </button>
              </div>
            
            </div>

          </div>
        </div>
        <div v-if="purchase && purchaseItemsReady"  style="margin-top:30px;">
          <strong>3. Purchase Order Items</strong>
            <table class="table table-hover">
                <thead>
                  <th>No.</th>
                  <th>Product Description</th>
                  <th>Unit</th>
                  <th>Qty</th>
                  <th>Qty Fulfilled</th>
                  <th>Qty Received</th>
                      <th>Price</th>
                      <th>Amount</th>
                      <th>Condition</th>
                  <th>Comments</th>
                  <th>Action</th>
                </thead>
              <tbody v-if="purchase.PurchaseProduct?.length > 0">
                    <tr v-for="(item, index) in purchase?.PurchaseProduct" v-bind:key="item.id"
                      :class="{ 'fulfilled-row': (item.remainingQuantity ?? item.quantity) <= 0 }">
                      <td>{{ (index+1) }}</td>
                      <td>{{ item.Product?.name }}</td>
                      <td>{{ item.Product?.unit?.unit }}</td>
                      <td>{{ item?.quantity }}</td>
                      <td>{{ item.alreadyReceived ?? 0 }}</td>
                      <td>
                        <input class="form-control" type="number" min="0" :id="`quantity${item.id}`" v-model.number="item.receivedQuantity" :max="item.remainingQuantity ?? item.quantity" @input="onReceivedQtyChange(item)" :disabled="(item.remainingQuantity ?? item.quantity) <= 0" />
                        <small v-if="(item.remainingQuantity ?? item.quantity) <= 0" class="text-muted"></small>
                      </td>
                      <td>
                        <input class="form-control" type="number" step="0.01" min="0" :id="`price${item.id}`" v-model.number="item.price" @input="recalcAmount(item)" :disabled="(item.remainingQuantity ?? item.quantity) <= 0" />
                      </td>
                      <td>
                        <input class="form-control" type="number" step="0.01" min="0" :id="`amount${item.id}`" :value="item.receivedAmount ?? (Number(item.price || 0) * Number(item.receivedQuantity || 0)).toFixed(2)" disabled />
                      </td>
                      <td>
                          <select :id="`condition${item.id}`" class="full" :disabled="(item.remainingQuantity ?? item.quantity) <= 0">
                              <option value="New">New</option>
                              <option value="Used">Used</option>
                          </select>
                      </td>
                      <td><input class="form-control" type="text" :id="`comment${item.id}`" :disabled="(item.remainingQuantity ?? item.quantity) <= 0"/></td>
                      <td>
                          <button class="btn btn-primary btn-sm" 
                            :class="{ 'btn-success': isItemCompleted(item.id) }"
                            style="border:1px solid black;" 
                            :id="`button${item.id}`" 
                            @click="completeItem(item.id, item.Product?.id)"
                            :disabled="isCompletingItem === item.id || isItemCompleted(item.id) || (item.remainingQuantity ?? item.quantity) <= 0">
                              <span v-if="isCompletingItem === item.id">
                                Completing
                                <img src="../../../assets/images/loader.gif" style="width: 20px; margin-left: 5px"/>
                              </span>
                              <span v-else-if="isItemCompleted(item.id)">Completed</span>
                              <span v-else>Complete</span>
                            </button>
                      </td>
                  </tr>
              </tbody>
              <!--
              <div v-else>
                <label for="" class="text-danger" style="margin: 0px auto; width: fit-content; text-align: center; display: block;">No items found</label>
              </div>
              -->
              
          </table>
          
          <div>
            <button class="btn-style small" style="border: 1px solid black; float: right;" @click="isVisible =true" :disabled="isProcessing || !canProcess">
              <span v-if="!canProcess" class="text-muted">Process (complete at least one item)</span>
              <span v-else>Process</span>
            </button>
            <!-- <button class="btn btn-success" style="float: right; margin-right: 10px;" @click="this.$router.push('/transaction')">Save</button>-->
            <button class="btn btn-default" style="border: 1px solid black; float: right; margin-right: 10px;" @click="cancelBatchAlert" :disabled="isCancelling">
              <span v-if="isCancelling">Cancelling <img src="../../../assets/images/loader.gif" style="width: 16px; margin-left: 5px"/></span>
              <span v-else>Cancel</span>
            </button>
          </div>
        </div>
        <div v-else-if="purchase && !purchaseItemsReady" style="margin-top:30px;">
          <strong>3. Purchase Order Items</strong>
          <div class="text-muted" style="padding:14px">Preparing purchase items…</div>
        </div>

        <div v-if="!purchase" :style="{ 'display': displayItems }" style="margin-top:30px;">
          <strong>3. Add Items</strong>
          <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label for="supplierContact">Product Description</label>
                  <Select2 class="select2" v-if="products.length > 0" style="width: 100% !important;" v-model="productId" :options="productOptions" :settings="{ width: 'resolve', selectionCssClass: ':all:' }" />
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Unit</label>
                  <input class="form-control"  type="text" v-model="itemUnit" />
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Quantity</label>
                  <input class="form-control" type="number" min="0" v-model.number="quantity" />
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Price</label>
                  <input class="form-control" type="number" step="0.01" min="0" v-model.number="price"/>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Amount</label>
                  <input class="form-control" type="number" step="0.01" min="0" :value="itemAmount" disabled />
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Condition</label>
                  <select v-model="condition"  class="full" >
                    <option value="New">New</option>
                    <option value="Used">Used</option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="supplierContact">Comments</label>
                  <input class="form-control" type="text" v-model="comment"/>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="supplierContact">Warehouse</label>
                  <select v-model="warehouseId" class="full" id="warehouses"  v-if="warehouses.length > 0">
                      <option v-for="warehouse in warehouses" v-bind:Key="warehouse.id" :value="warehouse.id">
                          {{ warehouse.name }} <span v-if="warehouse.isVirtual == true"> - {{ warehouse.description }}</span>
                      </option>
                  </select>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Section</label>                  
                  <select v-model="sectionId" class="full" id="sections">
                    <option v-for="section in sections" v-bind:Key="section.id" :value="section.id">
                        {{ section.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <button class="btn-style small" style="margin-top: 25px" @click="postItem" :disabled="isPostingItem">
                    <span v-if="isPostingItem">Adding <img src="../../../assets/images/loader.gif" style="width:14px; margin-left:6px"/></span>
                    <span v-else>Add</span>
                  </button>
                </div>
              </div>

          </div>
            <table class="table table-hover">
              <thead>
                  <th>No.</th>
                  <th>Product Description</th>
                  <th>Unit</th>
                  <th>Qty</th>
                  <th>Price (Kshs)</th>
                  <th>Condition</th>
                  <th>Location</th>
                  <th>Comments</th>
                  <th>Action</th>
              </thead>
              <tbody v-if="items.length > 0">
                  <tr v-for="(item, index) in items" v-bind:key="item.id">
                      <td>{{ (index+1) }}</td>
                      <td>{{ item.Product.name }}</td>
                      <td>{{ item.Product?.unit?.unit }}</td>
                      <td>{{ item.quantity }}</td>
                      <td>{{ formatMoney(item.price) }}</td>
                      <td>{{ item.condition }}</td>
                      <td>{{ item.Warehouse?.name }}</td>
                      <td>{{ item.comment }}</td>
                      <td>
                                          <button class="btn btn-default btn-sm" style="border:1px solid black;" @click="removeItem(item.id)" :disabled="isRemovingItem">
                            <span v-if="isRemovingItem">
                              Removing
                              <img src="../../../assets/images/loader.gif" style="width: 16px; margin-left: 5px"/>
                            </span>
                            <span v-else>Remove</span>
                          </button>
                      </td>
                  </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="9">
                    <label for="" class="text-danger mt-2" style="margin: 0px; display: block;">No items found</label>
                  </td>
                </tr>
              </tbody>
          </table>

          <div>
            <button class="btn-style small" style="margin-bottom: 20px; border: 1px solid black; float: right;" @click="isVisible =true" :disabled="isProcessing || !canProcess">
              <span v-if="!canProcess" class="text-muted">Process (add at least one item)</span>
              <span v-else>Process</span>
            </button>
            <!--<button class="btn btn-success" style="margin-bottom: 20px; float: right; margin-right: 10px;" @click="this.$router.push('/transaction')">Save</button>-->
            <button class="btn btn-default" style="margin-bottom: 20px; border: 1px solid black; float: right; margin-right: 10px;" @click="cancelBatchAlert" :disabled="isCancelling">
              <span v-if="isCancelling">Cancelling <img src="../../../assets/images/loader.gif" style="width: 16px; margin-left: 5px"/></span>
              <span v-else>Cancel</span>
            </button>
          </div>
        </div>
        </section>
    </div>
  </AppLayout>

<Modal v-if="isVisible" @close="closeModal" >
  <template v-slot:header>
    <h3>Confirm Stock Entry</h3>
  </template>

  <template v-slot:body>
    <div class="row">
      <div class="col-md-12">
          <div class="check-button">
          <div class="form-group">
              <label>Entered stock has been physically verified by you?</label>
              <div class="components-button">
          <span class="switcher switcher-1">
              <input type="checkbox" id="switcher-1" v-model="isVerified">
              <label for="switcher-1"></label>
          </span>
              </div>
          </div>
          </div>
      </div>
      <div class="row">
        <label for="item-code">Assigned stock to guardian?</label>
        <div class="col-sm-4">
            <div class="check-button">
            <div class="form-group">
                <div class="components-button">
            <span class="switcher switcher-1">
                <input type="checkbox" id="switcher-1" v-model="isGuardian">
                <label for="switcher-1"></label>
            </span>
                </div>
            </div>
            </div>
        </div>
        <div class="col-sm-8 mt-1" :style="{ 'display': displayGuardian }">
          <select v-model="guardianId" class="col-7 full" id="guardians"  v-if="users.length > 0">
              <option v-for="user in users" v-bind:Key="user.id" :value="user.id">
                  {{ user.name }}
              </option>
          </select>
        </div>
      </div>
      <div class="form-group col-12">
        <label for="item-code">BPN Note</label>
        <input type="text" class="form-control" placeholder="Enter note regarding the stock batch" v-model="note">
      </div>
    </div>
  </template>

  <template v-slot:footer>
  <button class="btn btn-default" style="border: 1px solid black; float: right; margin-right: 10px;" @click="isVisible =false" :disabled="isProcessing">Cancel</button>
  <button class="btn-style small" style="border: 1px solid black; float: right;" @click="processBatch" :disabled="isProcessing || !canProcess">
    <span v-if="isProcessing">
      Processing
      <img src="../../../assets/images/loader.gif" style="width: 20px; margin-left: 5px"/>
    </span>
    <span v-else-if="!canProcess">Process (complete at least one item)</span>
    <span v-else>Process</span>
  </button>
  </template>
</Modal>

<Modal v-if="isVisiblePO" @close="closeModalPO" >
  <template v-slot:header>
    <h3>Select warehouse and section</h3> 
  </template>

  <template v-slot:body>
    <div class="row">
      <div class="col-md-12">
          <div class="form-group">
            <label for="supplierContact">Warehouse</label>     
            <select class="full" v-model="poWarehouseId"  v-if="warehouses.length > 0">
                <option v-for="warehouse in warehouses" v-bind:Key="warehouse.id" :value="warehouse.id">{{ warehouse.name }} <span v-if="warehouse.isVirtual == true"> - {{ warehouse.description }}</span></option>
            </select>
          </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="supplierContact">Section</label>                  
          <select v-model="poSectionId" class="full" id="sections">
            <option v-for="section in sections" v-bind:Key="section.id" :value="section.id">
                {{ section.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </template>

  <template v-slot:footer>
  <button class="btn btn-default" style="border: 1px solid black; float: right; margin-right: 10px;" @click="isVisiblePO =false">Cancel</button>
  <button class="btn-style small" style="border: 1px solid black; float: right;" @click="postCompleteItem" :disabled="isCompletingItem === poItemId">
    <span v-if="isCompletingItem === poItemId">Completing <img src="../../../assets/images/loader.gif" style="width:14px; margin-left:6px"/></span>
    <span v-else>Complete Item</span>
  </button>
  </template>
</Modal>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import Swal from 'sweetalert2'

import Modal from '../../../components/Modal.vue';
import AppLayout from '../../../components/AppLayout.vue';
import axios from 'axios'
import { ref } from 'vue';
import Select2 from 'vue3-select2-component';

export default {
  name: 'AddBatchPage',
  components: {
    AppLayout,
    Modal,
    Select2,
  },
  data: () => ({
      token: JSON.parse(localStorage.getItem('access_token')),
      items: [],
      sections: [],
      products: [],
      productOptions:[],
      displayItems: "none",
      displayGuardian: "block",
      DriverDisplay: "block",
      SupplierDisplay: "block",
      purchase:"",
      purchaseItemsReady: false,
      batchId: "",
      isVisible:false,
      isVisiblePO: false,
      dynamicValue : ref(0),
      isInternal: true,
      stockCategory: "",
      driverId: "",
      driver: "",
      contacts: "",
      vehicle: "",
      project: "",
      document: "",
      reference1: "",
      reference2: "",
      referenceDocument: "",
      nogId: "",
      tagId: 0,
      warehouseId: "",
      sectionId: "",
      supplierId: null,
      purchaseId: null,
      productId: "",
      quantity: "",
      price: "",
      condition: "",
      comment: "",
      batchNo: "",
      itemUnit: "",
      itemSubUnit: "",
      itemNog: "",
      isVerified: true,
      isGuardian: true,
      guardianId: "",
      note: "",
      poSectionId:"",
      poWarehouseId:"",
      poQuantity:"",
      poPrice:"",
      poCondition:"",
      poComment:"",
      poProductId:"",
      poItemId:"",
      isCreatingBatch: false,
      isCompletingItem: null,
      isProcessing: false,
        isPostingItem: false,
        isRemovingItem: false,
        isSplitting: false,
        isCancelling: false,
      completedItems: [],
  }),
  computed:{
      ... mapGetters (["getSuppliers", "getUsers", "getNogs", "getPurchases", "getPurchasenos", "getWarehouses", "getTags", "getProjects", "getDocumentTypes"]),
      suppliers () { return this.getSuppliers },
      users () { return this.getUsers },
      nogs () { return this.getNogs },
      purchases () { return this.getPurchases },
      purchasenos () { return this.getPurchasenos },
      purchasenosFiltered () {
        const list = (this.purchasenos || []).filter(p => (p.canBeFulfilled === true && p.status !== 'fulfilled') || p.status === 'partial');
        const seen = new Set();
        const unique = [];
        for (const p of list) {
          const key = String(p.purchaseNo || p.id || '');
          if (!seen.has(key)) {
            seen.add(key);
            unique.push(p);
          }
        }
        return unique;
      },
      warehouses () { return this.getWarehouses },
      tags () { return this.getTags },
      projects () { return this.getProjects},
      documentTypes () { return this.getDocumentTypes },
      itemAmount() {
        const q = Number(this.quantity) || 0
        const p = Number(this.price) || 0
        return parseFloat((q * p).toFixed(2))
      },
      canProcess() {
        // For purchase-linked batches require at least one completed PO item.
        // For non-purchase batches require at least one added item.
        if (this.purchase) {
          return (this.completedItems || []).length > 0;
        }
        return (this.items || []).length > 0;
      },
  },
  mounted(){
      this.fetchSuppliers(),
      this.fetchUsers(),
      this.fetchPurchases(),
      this.fetchPurchasenos(),
      this.fetchWarehouses(),
      this.fetchTags(),
      this.fetchNogs(),
      this.setupProducts(),
      this.fetchProjects(),
      this.fetchDocumentTypes()

  },
  methods:{
      ... mapActions(['fetchSuppliers','fetchUsers', 'fetchNogs', 'fetchPurchases','fetchPurchasenos','fetchWarehouses','fetchTags', 'fetchProjects', 'fetchDocumentTypes']),
      statusLabel(status) {
        if (!status) return 'Unknown'
        const s = status.toString().toLowerCase()
        if (s === 'ceo_stamped' || s === 'ceo-stamped' || s === 'ceo stamped') return 'CEO Approved'
        if (s === 'stamped' || s === 'finance_stamped' || s.includes('stamped')) return 'Finance Approved'
        if (s === 'partial' || s === 'partially' || s === 'partially_fulfilled' || s === 'partially-fulfilled') return 'Partial Receipt'
        return status.toString()
      },
      async setupProducts(){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/products', requestOptions)
        this.products = await res.json()
        this.productOptions = [];
        this.productOptions.push({ id: 0, text: "All"})
        this.products.forEach(product => {
          this.productOptions.push({ id: product.id, text: product.name})
        });
      },
      closeModal() {
        this.isVisible = false;
      },
      closeModalPO() {
        this.isVisiblePO = false;
      },
      async processBatch () {
          if(this.batchId == "") {
            Swal.fire({
                icon: 'error',
                title: 'Batch not Found',
                text: "Try again or create a new batch"
            })
            return false;
          }

          if (!this.canProcess) {
            Swal.fire({ icon: 'error', title: 'Cannot Process', text: 'Complete at least one item before processing the batch.' });
            return false;
          }

          this.isProcessing = true
          try {
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
                body: JSON.stringify({ 
                  batchId: this.batchId,
                  isVerified: this.isVerified,
                  isGuardian: this.isGuardian,
                  guardianId: this.guardianId,
                  note: this.note,
                })
            };
            const res = await fetch(process.env.VUE_APP_URL+'/batches/process', requestOptions)
            const data = await res.json()
            if(data.status == true){
                Swal.fire({
                  position: 'top-center',
                  icon: 'success',
                  title: 'Batch Processed',
                  showConfirmButton: false,
                  timer: 1500
                })  
                this.$router.push('/transaction')         
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Batch not Processed',
                    text: data.message
                })
            }
          } catch (err) {
            console.error(err)
            Swal.fire({ icon: 'error', title: 'Error', text: err.message || 'An error occurred' })
          } finally {
            this.isProcessing = false
          }
      },
      cancelBatchAlert(){
          Swal.fire({
            title: 'Confirm Batch Cancellation',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, cancel it!'
          }).then((result) => {
            if (result.isConfirmed) {
              this.cancelBatch();
            }
          })
      },
      async cancelBatch () {
          const requestOptions = {
              method: "GET",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
          };
          const res = await fetch(process.env.VUE_APP_URL+'/batches/cancel/'+this.batchId, requestOptions)
          const data = await res.json()
          if(data.status == true){
              Swal.fire({
                position: 'top-center',
                icon: 'success',
                title: 'Batch Cancelled',
                showConfirmButton: false,
                timer: 1500
              })
              this.$router.push('/transaction')          
          }else{
              Swal.fire({
                  icon: 'error',
                  title: 'Batch Cancellation Failed',
                  text: data.message
              })
          }
      },
      splitBatchModal(){
        Swal.fire({
          title: 'Confirm',
          text: "Kindly confirm that you want to split receipt.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#000000',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirm'
        }).then((result) => {
          if (result.isConfirmed) {
            this.splitBatch()
          }
        })
      },
      async splitBatch(){
            this.isSplitting = true;
            try {
              const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              };
              const res = await fetch(process.env.VUE_APP_URL+'/batches/split/'+this.batchId, requestOptions)
              const data = await res.json()
              if(data.status == true){
                  Swal.fire({
                    position: 'top-center',
                    icon: 'success',
                    title: 'Batch Splitted',
                    showConfirmButton: false,
                    timer: 1500
                  })       
              }else{
                  Swal.fire({
                      icon: 'error',
                      title: 'Batch Split Failed',
                      text: data.message
                  })
              }
            } finally {
              this.isSplitting = false;
            }
      },
      async removeItem (itemId) {
          this.isRemovingItem = true;
          try {
          const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            body: JSON.stringify({ 
              itemId: itemId,
              batchId: this.batchId,
            })
          };
          const res = await fetch(process.env.VUE_APP_URL+'/batches/items/delete', requestOptions)
          const data = await res.json()
          if(data.status == true){
            this.items = data.items
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Batch Item not found',
              text: data.message
            })
          }
          } finally {
          this.isRemovingItem = false;
          }
      },
      async postBatch () {
        this.isCreatingBatch = true;
        try {
          let formData = new FormData()
          formData.append("name", this.name)
          formData.append("isInternal", this.isInternal)
          formData.append("driverId", this.driverId)
          formData.append("driver", this.driver)
          formData.append("contacts", this.contacts)
          formData.append("vehicle", this.vehicle)
          formData.append("project", this.project)
          formData.append("document", this.document)
          formData.append("reference1", this.reference1)
          formData.append("reference2", this.reference2)
          formData.append("file", this.referenceDocument)
          formData.append("nogId", this.nogId)
          formData.append("tagId", this.tagId)
          formData.append("supplierId", this.supplierId)
          formData.append("purchaseId", this.purchaseId)

          console.log("Document Type", this.document)

          const response = await axios.post(process.env.VUE_APP_URL+'/batches', formData, {
            headers:{ 
              "Content-Type": "multipart/form-data", 
              'Authorization': 'Bearer '+this.token 
            }})
          if (response.data.status === true) {
            this.batchId = response.data.batch.id
            this.purchase = response.data.purchase
            this.displayItems = "block"
            this.setupPurchase()
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Batch not created',
              text: response.data.message
            })
          }
        } finally {
          this.isCreatingBatch = false;
        }
      },
      async postItem () {
          this.isPostingItem = true;
          try {
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
                  body: JSON.stringify({ 
                    productId: this.productId,
                    batchId: this.batchId,
                    quantity: this.quantity,
                    price: String(this.price),
                    condition: this.condition,
                    comment: this.comment,
                    batchNo: this.batchNo,
                    warehouseId: this.warehouseId,
                    sectionId: this.sectionId,
                  })
            };
            const res = await fetch(process.env.VUE_APP_URL+'/batches/items', requestOptions)
            const data = await res.json()
            if(data.status == true){
                this.items = data.items
                this.displayItems = "block"
                this.quantity = ""
                this.price = ""
                this.condition = "new"
                this.comment = ""
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Batch Item not created',
                    text: data.message
                })
            }
          } finally {
            this.isPostingItem = false;
          }
      },

      async setupPurchase(){
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };

            try{
              // mark not ready while we fetch and compute
              this.purchaseItemsReady = false;
              const res = await fetch(process.env.VUE_APP_URL+'/purchases/'+this.purchaseId, requestOptions)
              const data = await res.json()
              if(data.status == true){
                  this.purchase = data.purchase;
                  // initialize per-item helpers: store original unit price and receivedQuantity
                  // fetch related batches for this purchase. Backend now returns per-PP items
                  // with `alreadyReceived` and `remainingQuantity` when available.
                  const relatedBatches = await this.fetchBatchesForPurchase(this.purchaseId);
                  // backend shape: [{ items: [...] }] where items contain id/productId/alreadyReceived/remainingQuantity
                  const backendItems = (relatedBatches && relatedBatches.length > 0 && Array.isArray(relatedBatches[0].items)) ? relatedBatches[0].items : null;

                  (this.purchase.PurchaseProduct || []).forEach(it => {
                    const orderedQty = Number(it.quantity) || 0;
                    const rawPrice = Number(it.price) || 0;
                    let unit = Number(it.unitPrice) || 0;
                    if (!unit) {
                      // prefer backend price as unit price; fallback to total/qty when necessary
                      if (rawPrice >= 1) unit = rawPrice;
                      else if (orderedQty > 0) unit = rawPrice / orderedQty;
                    }
                    it.unitPrice = unit;

                    if (backendItems) {
                      // prefer exact match by purchaseProduct id, fallback to productId
                      const match = backendItems.find(bi => Number(bi.id) === Number(it.id) || Number(bi.purchaseProductId) === Number(it.id) || Number(bi.productId) === Number(it.productId));
                      if (match) {
                        // backend provides authoritative alreadyReceived/remainingQuantity
                        it.alreadyReceived = Number(match.alreadyReceived ?? match.receivedQuantity ?? match.quantity ?? 0);
                        it.remainingQuantity = Number(match.remainingQuantity ?? Math.max(0, orderedQty - (match.quantity ?? 0)));
                        it.receivedQuantity = it.remainingQuantity;
                        // store unit price separately and compute received amount
                        it.price = parseFloat(unit.toFixed(2));
                        it.receivedAmount = parseFloat((unit * (Number(it.receivedQuantity) || 0)).toFixed(2));
                        return; // next item
                      }
                    }

                    // fallback: compute from returned batch items (older shape)
                    const alreadyReceived = (relatedBatches || []).reduce((acc, b) => {
                      const items = b.items || [];
                      const matchingByPP = items.find(x => Number(x.purchaseProductId) === Number(it.id));
                      if (matchingByPP) return acc + (Number(matchingByPP.quantity) || 0);
                      const matchingByProduct = items.find(x => Number(x.productId) === Number(it.productId) || Number(x.productId) === Number(it.Product?.id));
                      if (matchingByProduct) return acc + (Number(matchingByProduct.quantity) || 0);
                      return acc;
                    }, 0);
                    it.alreadyReceived = alreadyReceived;
                    const remaining = Math.max(0, orderedQty - alreadyReceived);
                    it.remainingQuantity = remaining;
                    it.receivedQuantity = remaining;
                    it.price = parseFloat(unit.toFixed(2));
                    it.receivedAmount = parseFloat((unit * (Number(it.receivedQuantity) || 0)).toFixed(2));
                  })
                  console.log("Purchase", this.purchase)
                  console.log("Purchase Product",this.purchase.PurchaseProduct)
                  // ready to render purchase items with prefilled values
                  this.purchaseItemsReady = true;
              }else{
                console.log("error fetching purchases")
                this.purchaseItemsReady = false;
              }
            }catch(err){
              console.log(err)
              this.purchaseItemsReady = false;
            }
            
      },

      async fetchBatchesForPurchase(purchaseId){
        if(!purchaseId) return [];
        const headers = { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token };
        try {
          const res = await fetch(process.env.VUE_APP_URL+`/batches/purchase/${purchaseId}/items`, { method: 'GET', headers });
          if(!res.ok) return [];
            const data = await res.json();
            // new endpoint format: { status: true, purchaseId, items: [...] }
            if (data && Array.isArray(data.items)) return [{ items: data.items }];
            // otherwise return empty; we rely on the backend contract for stability
            return [];
        } catch (e) {
          return [];
        }
      },

      async completeItem (itemId, productId) {
        // prefer reading values from the item object (keeps input-driven updates consistent)
        const item = (this.purchase?.PurchaseProduct || []).find(p => p.id === itemId) || null;
        if (item) {
          // clamp poQuantity to remainingQuantity to prevent processing already-fulfilled qty
          const remaining = Number(item.remainingQuantity ?? item.quantity) || 0;
          const requested = Number(item.receivedQuantity ?? item.quantity) || 0;
          this.poQuantity = Math.min(requested, remaining);
          this.poPrice = item.price;
        } else {
          // fallback to DOM lookups if item not present
          this.poQuantity = document.getElementById('quantity'+itemId)?.value;
          this.poPrice = document.getElementById('price'+itemId)?.value;
        }
        this.poCondition = document.getElementById('condition'+itemId)?.value;
        this.poComment = document.getElementById('comment'+itemId)?.value;
        this.poProductId = productId;
        this.poItemId = itemId;
        this.isVisiblePO = true;
      },
      async postCompleteItem () {
          this.isCompletingItem = this.poItemId;
          // Close modal immediately on click per UX requirement
          this.isVisiblePO = false;
        try {
          // ensure we do not post more than remaining quantity
          const poItem = (this.purchase?.PurchaseProduct || []).find(p => p.id === this.poItemId) || null;
          const maxAllowed = Number(poItem?.remainingQuantity ?? poItem?.quantity ?? 0) || 0;
          const qtyToSend = Math.min(Number(this.poQuantity) || 0, maxAllowed);

          const payload = {
            productId: this.poProductId,
            batchId: this.batchId,
            purchaseId: this.purchaseId, // send parent purchase id (fixed)
            purchaseProductId: this.poItemId, // include purchaseProduct id as reference
            quantity: qtyToSend,
            // backend expects price as a string
            price: String(this.poPrice),
            condition: this.poCondition,
            comment: this.poComment,
            warehouseId: this.poWarehouseId,
            sectionId: this.poSectionId,
          };
          console.log('Posting batch item (complete) payload', payload);
          const requestOptions = { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer '+this.token }, body: JSON.stringify(payload) };
          const res = await fetch(process.env.VUE_APP_URL+'/batches/items', requestOptions)
          const data = await res.json()
          if(data.status == true){
              this.completedItems.push(this.poItemId);
              let btn = document.getElementById('button'+this.poItemId)
              btn.classList.add('btn-success')
              btn.classList.remove('btn-primary')
              btn.value = 'Done'
              this.isVisiblePO = false;
          } else {
              Swal.fire({
                  icon: 'error',
                  title: 'Batch Item not created',
                  text: data.message
              })
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Error completing item',
            text: error.response?.data?.message || 'An error occurred'
          })
        } finally {
          this.isCompletingItem = null;
        }
      },
      onReceivedQtyChange(item) {
        this.recalcAmount(item);
      },

      recalcAmount(item) {
        const unit = Number(item.unitPrice ?? item.price) || 0;
        const qty = Number(item.receivedQuantity) || 0;
        item.receivedAmount = parseFloat((unit * qty).toFixed(2));
      },
      handleFileChange() {
        this.referenceDocument = this.$refs.fileDocument.files[0];
      },
      isItemCompleted(itemId) {
        return this.completedItems.includes(itemId);
      }
  },
  watch:{
      productId(newValue){
        const parsedValue = parseInt(newValue)
        let productObj = this.products.find(i => i.id === parsedValue);
        this.itemUnit = productObj?.unit?.unit
        this.itemNog = productObj?.Category?.category
        this.itemSubUnit = "None"
      },
      warehouseId(newValue){
          let obj = this.warehouses.find(i => i.id === newValue);
          this.sections = obj.sections
          this.sectionId = ""
      },
      poWarehouseId(newValue){
          let obj = this.warehouses.find(i => i.id === newValue);
          this.sections = obj.sections
          this.poSectionId = ""
      },
      isGuardian(newValue){
        if(newValue)
          this.displayGuardian = "block"
        else
          this.displayGuardian = "none"
        
      },
      isInternal(newValue) {
        if(newValue){
          this.DriverDisplay = "block"
          this.SupplierDisplay = "none"
        } else{
          this.DriverDisplay = "none"
          this.SupplierDisplay = "block"
        }
      }
  }
}
</script>

<style lang="scss" scoped>
  $text-color: #000000;
  $primary: #d2d2d2;
  $green: #000000;
  $white: #ffffff;
  select {
    /* inline SVG */
    background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
    background-position: right 10px center;
    background-repeat: no-repeat;
    background-size: auto 50%;
    border-radius: 3px;
    height: 40px;
    border: 1px solid #b4c7e7 !important;
    padding: 5px 30px 5px 10px;
    // disable default appearance
    outline: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    &::-ms-expand { display: none };
    &.full{
      width: 100%;
    }
    &:focus, &:hover{
      background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
      border: 1px solid $text-color;
      background-position: right 10px center;
      background-repeat: no-repeat;
      background-size: auto 50%;
    }
  }

  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 14px;
                font-weight: 600;
                font-size: 14px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 14px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                    height: 30px !important;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    background: $green;
                    height: 30px !important;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                  }
                }
              }
            }
          }
        }
      }

  
  .fulfilled-row {
    background-color: #f3f4f6 !important;
    color: #6c757d;
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
  }
  .fulfilled-row td {
    background-color: transparent !important;
    color: #6c757d !important;
  }
</style>
